<template>
  <div class="bench-container">
    <layout
      :indData="indData"
      :isDraggable="true"
      :isResizable="true"
      :isResponsive="true"
      :rowHeight="200"
      :sortKey="'id'"
      @moved="getMovedData"
    >
      <template slot="item" slot-scope="data">
        <a-card :title="`面板${data.item.i}`" class="w-full h-full"></a-card>
      </template>
    </layout>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import Layout from './components/layout.vue'
  import Layout from './vueGridLayout/index.vue'
  export default {
    name: 'WobenchIndex',
    components: {
      Layout
    },
    // 定义属性
    data () {
      return {
        indData: [
          { id: 0 },
          { id: 1 },
          { id: 2 },
          { id: 3 },
          { id: 4 },
          { id: 5 },
        ],

        loading: true
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      // const that = this
      // const resultLayout = that.layout.reduce((pre, cur) => {
      //   cur.components = (resolve) => require([`@/views/workbench/components/${cur.view}.vue`], resolve)
      //   pre.push(cur)
      //   return pre
      // }, [])
      // console.info(JSON.stringify(resultLayout))
      // this.layoutData = resultLayout
      // that.loading = false
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      getMovedData (v) {
        console.log('拖拽排序之后：', v)
      }
    }
  }
</script>

<style lang='less' scoped>
  .bench-container {
    background: #fff;
    height: 100%;
    padding-bottom: 20px;
  }
</style>